type AddressComponent = {
  long_name: string;
  short_name: string;
  types: string[];
};

export const getRegularAddressStreet = (
  addressComponents: AddressComponent[],
): string => {
  const fallbackValue = '';

  if (!addressComponents) {
    return fallbackValue;
  }

  const addressRoute = addressComponents.find((component) =>
    component.types.includes('route'),
  );

  return addressRoute ? addressRoute.long_name : fallbackValue;
};

export const getRegularShortNameStreet = (
  addressComponents: AddressComponent[],
): string => {
  const fallbackValue = '';

  if (!addressComponents) {
    return fallbackValue;
  }

  const addressRoute = addressComponents.find((component) =>
    component.types.includes('route'),
  );

  return addressRoute ? addressRoute.short_name : fallbackValue;
};

export const getRegularAddressNumber = (
  addressComponents: AddressComponent[],
): string => {
  const fallbackValue = '';

  if (!addressComponents) {
    return fallbackValue;
  }

  const addressNumber = addressComponents.find((component) =>
    component.types.includes('street_number'),
  );

  return addressNumber ? addressNumber.long_name : fallbackValue;
};

export const getRegularMunicipality = (
  addressComponents: AddressComponent[],
): string => {
  const fallbackValue = '';

  if (!addressComponents) {
    return fallbackValue;
  }

  const municipality = addressComponents.find(
    (component) =>
      component.types.includes('locality') ||
      component.types.includes('sublocality'),
  );

  return municipality ? municipality.long_name : fallbackValue;
};

export const getRegularPostalCode = (
  addressComponents: AddressComponent[],
): string => {
  const fallbackValue = '';

  if (!addressComponents) {
    return fallbackValue;
  }

  const postalCode = addressComponents.find((component) =>
    component.types.includes('postal_code'),
  );

  return postalCode ? postalCode.long_name : fallbackValue;
};

export const getRegularCity = (
  addressComponents: AddressComponent[],
): string => {
  const fallbackValue = '';

  if (!addressComponents) {
    return fallbackValue;
  }

  const city = addressComponents.find((component: any) =>
    component.types.includes('locality'),
  );

  return city ? city.short_name : fallbackValue;
};

export const getRegularState = (
  addressComponents: AddressComponent[],
): string => {
  const fallbackValue = '';

  if (!addressComponents) {
    return fallbackValue;
  }

  const state = addressComponents.find((component) =>
    component.types.includes('administrative_area_level_1'),
  );

  return state ? state.short_name : fallbackValue;
}